import Cookies from 'js-cookie';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { listShippingRates, listShippingAvailability } from './api';
import {
  LIST_SHIPPING_REQUEST,
  LIST_SHIPPING_SUCCESS,
  RESET_SHIPPING_ISFETCHING,
  SHIPPING_LIST_REQUESTING,
  LIST_SHIPPING_AVAILABILITY_REQUEST,
  SHIPPING_AVAILABILITY_LIST_REQUESTING,
  LIST_SHIPPING_AVAILABILITY_SUCCESS
} from './constants';

function* list(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: SHIPPING_LIST_REQUESTING });
    const response = yield call(
      listShippingRates,
      cartId(),
      action.stateCode,
      action.countryCode,
      action.zipCode
    );
    yield put({
      type: LIST_SHIPPING_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_SHIPPING_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* listAvailability() {
  try {
    yield call(removeAPIError);
    yield put({ type: SHIPPING_AVAILABILITY_LIST_REQUESTING });
    const response = yield call(listShippingAvailability);
    yield put({
      type: LIST_SHIPPING_AVAILABILITY_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_SHIPPING_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* watchList() {
  yield takeLatest(LIST_SHIPPING_REQUEST, list);
  yield takeLatest(LIST_SHIPPING_AVAILABILITY_REQUEST, listAvailability);
}

export default function* shippingSagas() {
  yield all([watchList()]);
}
const cartId = () => Cookies.get('cartId');
